<template>
  <div ref="viewPage" class="apply-add-form ">
    <h2 v-if="!hideFormName" class="text-primary" style="text-align: center">
      {{ formName }}
    </h2>

    <div class="apply-add-form__share">
      <template v-if="formId == 2 || formId == 29">
        <my-tooltip :tooltip="i18n('showLeaveHistory')">
          <b-button
            variant="primary"
            class="btn-icon mr-1"
            @click="handleShowLeaveHistory"
          >
            <feather-icon icon="ListIcon" />
          </b-button>
        </my-tooltip>
      </template>

      <my-tooltip tooltip="Print process">
        <b-button
          variant="secondary"
          class="btn-icon mr-1"
          @click="handlePrint"
        >
          <feather-icon icon="PrinterIcon" />
        </b-button>
      </my-tooltip>
      <my-tooltip tooltip="Share with other staff">
        <b-button variant="success" class="btn-icon" @click="handleShare">
          <feather-icon icon="Share2Icon" />
        </b-button>
      </my-tooltip>
    </div>

    <b-overlay
      :show="!formatData"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
      class="viewPageTodo"
    >
      <my-form
        v-if="formatData && formId != 44"
        ref="overFormRef"
        page-key="view"
        class="viewPageTodo"
        :formId="formId"
        :data="formatData"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <div v-else class="manual-box">
        <div>Staff:</div>
        <div class="blue_text mg_8 ">{{ data.staffName }}</div>
        <div class="mg_8">Manual Date:</div>
        <table class="mg_8" v-if="data.attendanceManualRecords" border>
          <tr>
            <th>
              Date
            </th>
            <th>
              clock In Time
            </th>

            <th>clock Out Time</th>

            <th>Remark</th>
          </tr>

          <tr
            v-for="(item, index) in JSON.parse(data.attendanceManualRecords)"
            :key="index"
          >
            <th>
              {{ item.attendanceDate }}
            </th>
            <th>
              {{ item.clockInTimeManual }}
            </th>

            <th>{{ item.clockOutTimeManual }}</th>

            <th v-html="item.remark.replace(/\n/g, '<br>')"></th>
          </tr>
        </table>
      </div>
      <div class="apply-add-form-line" />
      <time-line :data="formatHistoryData" />
      <b-img
        v-if="processInstanceId"
        :src="
          `/api/blade-flow/process/diagram-view?processInstanceId=${processInstanceId}&processDefinitionId=&?time=${new Date().getTime()}`
        "
      />
    </b-overlay>

    <slot name="audit" />
    <process-share :visible.sync="shareModalShow" :process-id="processId" />
    <c-modal
      :visible="showLeaveHistory"
      :title="'History'"
      body-class="process-modal"
      size="xl"
      :footer="false"
      @close="showLeaveHistory = false"
      @modelConfirm="showLeaveHistory = true"
    >
      <template slot="content">
        <component
          :is="'LeaveHistoryBlock'"
          v-if="showLeaveHistory"
          :user-info="data"
        />
      </template>
    </c-modal>
  </div>
</template>

<script>
// import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import templateFormAPI from '@/api/templateForm/index'
import TimeLine from '@/components/timeLine.vue'
import { BRow, BCol, BImg, BOverlay, BButton } from 'bootstrap-vue'
import CModal from '@/components/crud/modal.vue'
import { templateFormat, formatprocessHistoryData } from '@/util/func'
import MyTooltip from '@/components/myTooltip.vue'
import ProcessShare from '@/components/processShare.vue'
import LeaveHistoryBlock from './viewPage/LeaveHistoryBlock.vue'
import { deepClone } from '@/util/util'
import { getDetail } from '@/api/staff/businessTravel/index'
import { getTrainingDetail } from '@/api/staff/training/index'
import { staff } from '@/api/staff/index'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    TimeLine,
    BImg,
    BOverlay,
    BButton,
    MyTooltip,
    ProcessShare,
    CModal,
    LeaveHistoryBlock,
  },

  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    formId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    processInstanceId: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: undefined,
    },
    defaultColumns: {
      type: Array,
      default: undefined,
    },
    hideFormName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        isPass: false,
      },
      loading: false,
      formDataView: {},
      columns: [],
      historyData: [],
      shareModalShow: false,
      showLeaveHistory: false,
      formName: '',
      prApplicantStaffField: 'applicantId',
      prApplicantNameCache: '',
    }
  },
  computed: {
    option() {
      const columns = []
      const { data } = this
      console.log('sssssssssssss', data)
      this.formDataView = deepClone(data)
      this.columns.forEach((item) => {
        const temp = item
        if (this.formId === '2' || this.formId === 2) {
          if (item.field === 'departureDate' || item.field === 'arrivalDate') {
            temp.formOption.hide = Number(data.isLeave) !== 1
          }
          if (item.field === 'leavePeriod') {
            if (this.data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
          if (item.field === 'leaveUnit') {
            if (!data.leaveUnit) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }

          if (item.field === 'leaveEndTime') {
            if (data.leaveUnit === '0.5' || data.leaveUnit === 0.5) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
        }
        if (this.formId === '29' || this.formId === 29) {
          if (item.field === 'departureDate' || item.field === 'arrivalDate') {
            temp.formOption.hide = Number(data.isLeave) !== 1
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }

          if (item.field === 'leaveEndTime') {
            if (data.leaveUnit === '0.5' || data.leaveUnit === 0.5) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
          if (item.field === 'leaveUnit') {
            if (!data.leaveUnit) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
          if (item.field === 'leavePeriod') {
            if (data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
        }

        if (this.formId === 24) {
          if (item.field === 'resignation') {
            temp.disabled = true
          }
          if (item.field === 'remark') {
            if (
              data.resignation &&
              data.resignation.length &&
              data.resignation.includes('5')
            ) {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
            }
          }
          temp.disabled = true
        }

        if (this.formId === 36) {
          if (item.field === 'ot') {
            const dic = {
              0: 'Sun',
              1: 'Mon',
              2: 'Tue',
              3: 'Wed',
              4: 'Thu',
              5: 'Fri',
              6: 'Sat',
              7: 'Sun',
            }
            const arr = JSON.parse(data.ot)
            arr.forEach((e) => {
              const { startTime, endTime } = e
              if (startTime.indexOf('(') === -1) {
                e.startTime = `${startTime} (${dic[moment(startTime).day()]})`
              }
              if (endTime.indexOf('(') === -1) {
                e.endTime = `${endTime} (${dic[moment(endTime).day()]})`
              }
            })
            data.ot = JSON.stringify(arr)
          }
        }
        if (this.formId == 305) {
          if (item.field === 'sectionARemark' && data.sectionA) {
            try {
              const sectionA = JSON.parse(data.sectionA)
              const tickValue = sectionA[7]?.tickValue
              temp.formOption = {
                ...temp.formOption,
                rules: tickValue == 1 ? 'required' : '',
              }
            } catch (error) {
              console.error('解析 sectionA 数据失败:', error)
            }
          }

          if (
            item.field === 'sectionBOperateOwnTable' &&
            data.sectionBOperateOwn !== undefined
          ) {
            temp.formOption = {
              ...temp.formOption,
              rules: data.sectionBOperateOwn == 1 ? 'required' : '',
              hide: data.sectionBOperateOwn == 1 ? false : true,
            }
          }

          if (
            item.field === 'sectionBImmediateFamilyTable' &&
            data.sectionBImmediateFamily !== undefined
          ) {
            temp.formOption = {
              ...temp.formOption,
              rules: data.sectionBImmediateFamily == 1 ? 'required' : '',
              hide: data.sectionBImmediateFamily == 1 ? false : true,
            }
          }

          if (
            item.field === 'sectionCRemark' &&
            data.sectionCRadio !== undefined
          ) {
            temp.formOption = {
              ...temp.formOption,
              rules: data.sectionCRadio == 1 ? 'required' : '',
            }
          }
        }

        if (
          item.field === 'tip1' &&
          data.tip1 !== undefined &&
          this.formId == 33
        ) {
          temp.formOption = {
            ...temp.formOption,
            hide: data.tip1 ? false : true,
            label: data.tip1,
          }
        }

        if (this.isPrForm316()) {
          if (this.isPrApplicantField(item)) {
            const refCol = this.columns.find(
              (col) => col.field === 'employeeCodeApplicant',
            )
            this.configurePrApplicantLikeEmployeeCode(temp, refCol)
          }
          if (
            ['employeeCodeApplicant', 'jointDate', 'nationalityApplicant'].includes(
              item.field,
            )
          ) {
            temp.formOption.disableFormControl = true
          }
          if (item.field === 'purposeApplication') {
            temp.formOption.textareaRows = 14
          }
        }

        columns.push(temp)
      })

      if (this.formId == 11) {
        const newData = [
          {
            label: 'Hotel Fee：',
            field: 'hotelFee',
            type: 'number',
            sort: 9995,
            hide: false,
            search: false,
            searchBase: false,
            multiple: false,
            formOption: {
              rules: '',
              type: 'number',
              span: 12,
              placeholder: '每日合计',
              formEditDisabled: true,
              dictBizCode: '',
              updateNow: true,
              dictCodeOrDictData: '1',
            },
            dictBizCode: '',
            disabled: true,
          },
          {
            label: 'Transportation Fee：',
            field: 'transportationFee',
            type: 'number',
            sort: 9995,
            hide: false,
            search: false,
            searchBase: false,
            multiple: false,
            formOption: {
              rules: '',
              type: 'number',
              span: 12,
              placeholder: '每日合计',
              formEditDisabled: true,
              dictBizCode: '',
              updateNow: true,
              dictCodeOrDictData: '1',
            },
            dictBizCode: '',
            disabled: true,
          },
        ]
        columns.splice(7, 0, ...newData)
      }

      const option = {
        columns,
      }
      console.log('配置信息', option)
      return option
    },
    formatData() {
      const { data } = this
      if (!data) return undefined
      if (!this.isPrForm316()) return data
      const field = this.prApplicantStaffField || 'applicantId'
      const displayName =
        this.prApplicantNameCache || data.applicantIdName || ''
      if (!displayName) return data
      return { ...data, [field]: displayName }
    },
    formatHistoryData() {
      return formatprocessHistoryData(this.historyData)
    },
  },
  watch: {
    processInstanceId: {
      handler(e) {
        if (e) {
          console.log(e, 'this.processInstanceId')
          applyAPI.history({ processInstanceId: e }).then((res) => {
            this.historyData = res.data.data
          })
        }
      },
      immediate: true,
    },
    formId: {
      handler(e) {
        if (e) {
          console.log(e, 'formId')
          this.onLoad(e)
        }
      },
      immediate: true,
    },
    data: {
      handler() {
        this.loadPrApplicantDisplayName()
      },
      deep: true,
    },
    // 'data.sectionA': {
    //   handler(val) {
    //     console.log(this.data, 'this.data', this.initDataLoading)

    //     const index = this.option.columns.findIndex(
    //       (item) => item.field === 'sectionARemark',
    //     )
    //     const newFormOption = this.option.columns[index]
    //     console.log(newFormOption)
    //     const sectionA = JSON.parse(this.data.sectionA)
    //     const tickValue = sectionA[7].tickValue
    //     newFormOption.formOption.rules = tickValue == 1 ? 'required' : ''

    //     this.$set(this.option.columns, index, newFormOption)
    //   },
    // },
    // 'data.sectionBOperateOwn': {
    //   handler(val) {
    //     const index = this.option.columns.findIndex(
    //       (item) => item.field === 'sectionBOperateOwnTable',
    //     )
    //     const newFormOption = this.option.columns[index]
    //     newFormOption.formOption.rules = val == 1 ? 'required' : ''
    //     newFormOption.formOption.hide = val == 1 ? false : true
    //     // this.data.sectionBOperateOwnTable = ''

    //     this.$set(this.option.columns, index, newFormOption)
    //   },
    // },
    // 'data.sectionBImmediateFamily': {
    //   handler(val) {
    //     const index = this.option.columns.findIndex(
    //       (item) => item.field === 'sectionBImmediateFamilyTable',
    //     )
    //     const newFormOption = this.option.columns[index]
    //     newFormOption.formOption.rules = val == 1 ? 'required' : ''
    //     newFormOption.formOption.hide = val == 1 ? false : true
    //     // this.data.sectionBImmediateFamilyTable = ''

    //     this.$set(this.option.columns, index, newFormOption)
    //   },
    // },
    // 'data.sectionCRadio': {
    //   handler(val) {
    //     const index = this.option.columns.findIndex(
    //       (item) => item.field === 'sectionCRemark',
    //     )
    //     const newFormOption = this.option.columns[index]
    //     newFormOption.formOption.rules = val == 1 ? 'required' : ''

    //     // this.data.sectionBImmediateFamilyTable = ''

    //     this.$set(this.option.columns, index, newFormOption)
    //   },
    // },
    // 'data.tip1': {
    //   handler(val) {
    //     const index = this.option.columns.findIndex(
    //       (item) => item.field === 'tip1',
    //     )
    //     const newFormOption = this.option.columns[index]
    //     newFormOption.formOption.hide = val ? false : true
    //     newFormOption.label = val

    //     this.$set(this.option.columns, index, newFormOption)
    //   },
    // },
  },
  created() {
    if (this.processId) {
      this.data = undefined
      this.id = this.processId
      if (this.formId === '39') {
        applyAPI.workerDetail({ id: this.processId }).then((res) => {
          const { data } = res.data
          this.$emit('onLoaded', data)
          this.processKey = data.processKey
          this.processInstanceId = data.processInstanceId
          this.formId = data.formId
          this.data = data.map || {}
        })
      } else {
        applyAPI.detail({ id: this.processId }).then((res) => {
          const { data } = res.data
          this.$emit('onLoaded', data)
          this.processKey = data.processKey
          this.processInstanceId = data.processInstanceId
          this.formId = data.formId
          this.formName = data.formName
          this.data = data.map
          this.loadPrApplicantDisplayName()
          // setTimeout(() => {
          //   this.data = data.map || {}
          // }, 3000)

          if (this.formId == 2 && this.data.leaveStartTime) {
            const nowYear = moment().format('YYYY')

            const startYear = moment(this.data.leaveStartTime).format('YYYY')

            if (startYear > nowYear) {
              ;(this.data.haveDaysTitle = 0),
                (this.data.pendingDays = 0),
                (this.data.usedDaysTitle = 0)
            }
          }
          if (this.formId == 11) {
            //Business Trave需要把业务里HR填写的费用并入工作流里展示
            getDetail({ processInstanceId: this.processId }).then((resData) => {
              const { data } = resData.data
              const {
                hotelFee,
                transportationFee,
                totalPerDiem,
                travelReimbursement,
              } = data || {}
              this.data = {
                ...this.data,
                hotelFee,
                transportationFee,
                totalPerDiem,
                travelReimbursement,
              }
            })
          }
          if (this.formId == 15) {
            //Training Application需要把业务里HR填写的费用并入工作流里展示
            getTrainingDetail({ processInstanceId: this.processId }).then(
              (resData) => {
                const { data } = resData.data
                const { courseFeeHr } = data || {}
                this.data = { ...this.data, courseFeeHr }
              },
            )
          }
        })
      }
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit')
    },
    handleShowLeaveHistory() {
      this.showLeaveHistory = true
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    resetForm() {
      this.form = {}
    },
    isPrForm316() {
      return Number(this.formId) === 316
    },
    isPrApplicantField(col) {
      return (
        col.field === this.prApplicantStaffField
        || col.field === 'applicantId'
        || /name of applicant/i.test(String(col.label || ''))
      )
    },
    findPrApplicantField(columns = this.columns) {
      const applicantCol =
        columns.find((col) =>
          /name of applicant/i.test(String(col.label || '')),
        )
        || columns.find((col) => col.field === 'applicantId')
        || columns.find((col) => {
          const disabled = [
            'employeeCodeApplicant',
            'jointDate',
            'nationalityApplicant',
          ]
          const dictCode =
            col.formOption?.dictCode || col.formOption?.dictBizCode
          return dictCode === 'staff' && !disabled.includes(col.field)
        })
      return applicantCol?.field || 'applicantId'
    },
    configurePrApplicantLikeEmployeeCode(col, referenceCol) {
      if (!col) return col
      const refType = referenceCol?.type || referenceCol?.formOption?.type || 'input'
      col.type = refType
      col.formOption.type = refType
      col.formOption.disableFormControl = true
      delete col.dictCode
      delete col.dictBizCode
      delete col.formOption.dictCode
      delete col.formOption.dictBizCode
      delete col.formOption.slot
      return col
    },
    setupPrApplicantColumns(columns) {
      if (!this.isPrForm316() || !columns?.length) return
      this.prApplicantStaffField = this.findPrApplicantField(columns)
      const applicantCol = columns.find(
        (col) => col.field === this.prApplicantStaffField,
      )
      const employeeCodeCol = columns.find(
        (col) => col.field === 'employeeCodeApplicant',
      )
      this.configurePrApplicantLikeEmployeeCode(applicantCol, employeeCodeCol)
      ;['employeeCodeApplicant', 'jointDate', 'nationalityApplicant'].forEach(
        (field) => {
          const col = columns.find((item) => item.field === field)
          if (col) {
            col.formOption.disableFormControl = true
          }
        },
      )
    },
    async loadPrApplicantDisplayName() {
      if (!this.isPrForm316() || !this.data) return
      if (this.data.applicantIdName) {
        this.prApplicantNameCache = this.data.applicantIdName
        return
      }
      const field = this.prApplicantStaffField || 'applicantId'
      const staffId = this.data[field]
      if (staffId) {
        try {
          const res = await staff.easyList(1, -1, {
            ids: String(staffId),
            statuses: '0,1,2,3',
          })
          const record = res.data.data.records?.[0]
          const name = record?.enName || record?.staffName || ''
          if (name) {
            this.prApplicantNameCache = name
            return
          }
        } catch (e) {
          // ignore
        }
      }
      const staffNo = this.data.employeeCodeApplicant
      if (!staffNo) {
        this.prApplicantNameCache = ''
        return
      }
      try {
        const res = await staff.getList(1, 1, { staffNo })
        const record = res.data.data.records?.[0]
        this.prApplicantNameCache =
          record?.enName || record?.staffName || ''
      } catch (e) {
        this.prApplicantNameCache = ''
      }
    },
    onLoad(formId) {
      if (this.defaultColumns) {
        this.columns = this.defaultColumns
        this.setupPrApplicantColumns(this.columns)
        this.loadPrApplicantDisplayName()
        return
      }
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        const tempArr = templateFormat(temp)
        const resArr = []
        tempArr.forEach((item) => {
          const params = item
          params.disabled = true
          resArr.push(params)
        })
        this.setupPrApplicantColumns(resArr)
        this.columns = resArr
        this.loadPrApplicantDisplayName()
      })
    },
    handleSubmit(form) {
      console.log(form)
      const params = form
      params.processKey = this.processKey
      params.formId = this.id
      applyAPI.edit(params).then((res) => {
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    transformArrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      for (let len = bytes.byteLength, i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    handleShare() {
      this.shareModalShow = true
    },
    handlePrint() {
      console.log(this.processId, 'processId')
      const p = this.$router.resolve({ path: '/processPrint' })
      window.open(`${p.href}?processId=${this.processId}`, '_bank')
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-add-form {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
  }
  &__share {
    position: absolute;
    top: -50px;
    right: 70px;
  }
}
.manual-box {
  padding-bottom: 16px;
  .blue_text {
    color: #7367f0;
  }
  .mg_8 {
    margin-top: 8px;
  }
  table {
    width: 80%;

    th {
      text-align: center;
    }
  }
}
</style>
